import { Box, styled } from '@mui/material';

import { GridRowName } from '../Grid/Grid';

export const ListViewAssessmentsStatusCell = styled(Box)(({ theme }) => ({
  flex: '0 0 130px',
  marginLeft: theme.spacing(2.5),

  [theme.breakpoints.down('md')]: {
    flex: '0 0 100px',
  },
}));

type ListViewAssessmentsRowActionsProps = {
  showActions?: boolean;
};

export const ListViewAssessmentsActionsCell = styled(Box)<ListViewAssessmentsRowActionsProps>(
  ({ theme, showActions }) => {
    const size = theme.spacing(2.5);

    const showActionsProps = {
      display: 'unset',
      color: theme.palette.text.secondary,
    };

    return {
      position: 'relative',
      marginLeft: theme.spacing(2.5),
      flex: `0 0 ${size}`,
      fontSize: size,
      minWidth: size,

      '& .MuiIconButton-root': {
        position: 'absolute',
        transform: 'translateY(-50%)',
        display: 'none',

        '.GridRowItem:hover &': {
          display: 'unset',
        },

        [theme.breakpoints.down('lg')]: showActionsProps,
        ...(showActions && showActionsProps),
      },
    };
  },
);

export const ListViewAssessmentsNameCell = styled(GridRowName)(({ theme }) => ({
  overflow: 'hidden',
  display: 'flex',
  gap: theme.spacing(1),
  alignItems: 'center',
  minWidth: 150,
  paddingRight: theme.spacing(2),

  '& .MuiIcon-root': {
    '.GridRow:hover &, .GridRowItem:hover &': {
      color: theme.palette.primary.main,
    },
  },
}));

export const ListViewAssessmentsEvaluationCell = styled(GridRowName)<{ isEmpty?: boolean }>(
  ({ theme, isEmpty }) => ({
    flex: '0 0 200px',

    '& .MuiTypography-root': {
      '.GridRow:hover &, .GridRowItem:hover &': {
        color: isEmpty ? theme.palette.text.primary : theme.palette.primary.main,
      },
    },

    [theme.breakpoints.down('md')]: {
      flex: '0 0 100px',
    },
  }),
);
